import {
  LOGIN_SUCCESS,
  LOGOUT_REQUEST,
  UPDATE_USER,
} from "../Actions/actionType";

const INITIAL_STATE = {
  isLogin: false,
  user: null,
  role: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        role: action.payload,
        isLogin: true,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: action.payload?.data,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        isLogin: false,
        user: null,
        role: null,
      };
    default:
      return state;
  }
};
